import { createApp } from "vue";
import { createPinia } from "pinia";
import { config } from "@fortawesome/fontawesome-svg-core";
import App from "./App.vue";
import router from "./router";
import TenantRouterLink from "@/components/TenantRouterLink.vue";
import tooltip from "@comp-lib/directives/tooltip";

import "@comp-lib/styles/global.scss";
import "@fortawesome/fontawesome-svg-core/styles.css";

// Disable auto CSS injection from FontAwesome to avoid CSP issues
config.autoAddCss = false;

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.component("RouterLink", TenantRouterLink);
app.directive("tooltip", tooltip);

app.mount("#app");
